"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _jsxRuntime = require("react/jsx-runtime");

function Paginator(props) {
  if (props.totalItems - props.pageSize < 1) {
    // If the pagination is not needed, the component is empty
    return null;
  }

  function getInformation() {
    if (props.information) {
      return props.information;
    }

    var toValue = (props.currentPage + 1) * props.pageSize > props.totalItems ? props.totalItems : (props.currentPage + 1) * props.pageSize;
    var fromValue = props.currentPage * props.pageSize + 1;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "pagination.items"
      }), "\xA0", fromValue, "\xA0", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "pagination.to"
      }), "\xA0", toValue, "\xA0", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "pagination.of"
      }), "\xA0", props.totalItems]
    });
  }

  var isLastPage = (props.currentPage + 1) * props.pageSize >= props.totalItems;
  var isFirstPage = Boolean(props.currentPage < 1);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "paginator",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "information",
      children: getInformation()
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "paginator-buttons-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        disabled: isFirstPage,
        onClick: function onClick(event) {
          return props.onChangePage(event, props.currentPage - 1);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "caret-left"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        disabled: isLastPage,
        onClick: function onClick(event) {
          return props.onChangePage(event, props.currentPage + 1);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "caret-right"
        })
      })]
    })]
  });
}

Paginator.propTypes = {
  information: _propTypes.default.string,
  totalItems: _propTypes.default.number.isRequired,
  pageSize: _propTypes.default.number.isRequired,
  currentPage: _propTypes.default.number.isRequired,
  onChangePage: _propTypes.default.func.isRequired
};
var _default = Paginator;
exports.default = _default;
//# sourceMappingURL=Paginator.js.map